import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

const LINKS = [
  { page: 'terms', label: 'Terms' },
  { page: 'privacy', label: 'Privacy' },
  { page: 'refunds', label: 'Refunds' },
  { page: 'contact', label: 'Contact' },
] as const

/** Footer links to the legal pages (Razorpay requires them to be reachable from the site). */
export function LegalLinks({ className }: { className?: string }) {
  const { t } = useTranslation()
  return (
    <nav
      aria-label={t('Legal')}
      className={cn('text-muted-foreground flex flex-wrap gap-x-4 gap-y-1 text-xs', className)}
    >
      {LINKS.map((l) => (
        <Link key={l.page} to="/legal/$page" params={{ page: l.page }} className="hover:text-foreground">
          {t(l.label)}
        </Link>
      ))}
    </nav>
  )
}
